{
  "INBOX_MGMT": {
    "HEADER": "收件匣",
    "DESCRIPTION": "頻道是客戶與您互動時選擇的溝通方式。收件匣是您管理特定頻道互動的地方，可以包含來自電子郵件、即時聊天和社群媒體等各種來源的通訊。",
    "LEARN_MORE": "進一步了解收件匣",
    "COUNT": "{n} 個收件匣",
    "SEARCH_PLACEHOLDER": "搜尋收件匣...",
    "NO_RESULTS": "找不到符合搜尋條件的收件匣",
    "RECONNECTION_REQUIRED": "您的收件匣已斷開連線。在您重新授權之前，將無法接收新訊息。",
    "CLICK_TO_RECONNECT": "點此重新連線。",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "您的 WhatsApp Business 註冊尚未完成。請在重新連線前至 Meta Business Manager 確認您的顯示名稱狀態。",
    "COMPLETE_REGISTRATION": "完成註冊",
    "LIST": {
      "404": "此帳戶沒有收件匣。"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "選擇頻道",
        "BODY": "選擇您想要與 Chatwoot 整合的服務供應商。"
      },
      "INBOX": {
        "TITLE": "建立收件匣",
        "BODY": "驗證您的帳戶並建立收件匣。"
      },
      "AGENT": {
        "TITLE": "新增客服人員",
        "BODY": "將客服人員新增到已建立的收件匣。"
      },
      "FINISH": {
        "TITLE": "完成！",
        "BODY": "一切準備就緒！"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "收件匣名稱",
        "PLACEHOLDER": "輸入您的收件匣名稱（例：Acme Inc）",
        "ERROR": "請輸入有效的收件匣名稱"
      },
      "WEBSITE_NAME": {
        "LABEL": "網站名稱",
        "PLACEHOLDER": "輸入您的網站名稱（例：Acme Inc）"
      },
      "FB": {
        "HELP": "注意：登入後，我們僅能存取您粉絲專頁的訊息。Chatwoot 永遠無法存取您的私人訊息。",
        "CHOOSE_PAGE": "選擇粉絲專頁",
        "CHOOSE_PLACEHOLDER": "從列表中選擇一個粉絲專頁",
        "INBOX_NAME": "收件匣名稱",
        "ADD_NAME": "為您的收件匣新增名稱",
        "PICK_NAME": "為您的收件匣選擇一個名稱",
        "PICK_A_VALUE": "選擇一個值",
        "CREATE_INBOX": "建立收件匣"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "繼續使用 Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "連結您的 Instagram 個人檔案",
        "HELP": "若要將您的 Instagram 個人檔案新增為頻道，請點擊「繼續使用 Instagram」來驗證您的 Instagram 個人檔案。",
        "ERROR_MESSAGE": "連結 Instagram 時發生錯誤，請重試",
        "ERROR_AUTH": "連結 Instagram 時發生錯誤，請重試",
        "NEW_INBOX_SUGGESTION": "此 Instagram 帳號先前連結至其他收件匣，現已遷移至此處。所有新訊息將顯示在此。舊收件匣將無法再為此帳號收發訊息。",
        "DUPLICATE_INBOX_BANNER": "此 Instagram 帳號已遷移至新的 Instagram 頻道收件匣。您將無法再從此收件匣收發 Instagram 訊息。"
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "繼續使用 TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "連結您的 TikTok 個人檔案",
        "HELP": "若要將您的 TikTok 個人檔案新增為頻道，請點擊「繼續使用 TikTok」來驗證您的 TikTok 個人檔案。",
        "ERROR_MESSAGE": "連結 TikTok 時發生錯誤，請重試",
        "ERROR_AUTH": "連結 TikTok 時發生錯誤，請重試"
      },
      "TWITTER": {
        "HELP": "若要將您的 Twitter 個人檔案新增為頻道，請點擊「使用 Twitter 登入」來驗證您的 Twitter 個人檔案。",
        "ERROR_MESSAGE": "連結 Twitter 時發生錯誤，請重試",
        "TWEETS": {
          "ENABLE": "從提及的推文建立對話"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "網站頻道",
        "DESC": "為您的網站建立一個頻道，透過網站小工具開始為客戶提供支援服務。",
        "LOADING_MESSAGE": "正在建立網站支援頻道",
        "CHANNEL_AVATAR": {
          "LABEL": "頻道頭像"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "請輸入您的 Webhook URL",
          "ERROR": "請輸入有效的 URL"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook 密鑰",
          "COPY": "複製密鑰至剪貼簿",
          "COPY_SUCCESS": "密鑰已複製至剪貼簿",
          "TOGGLE": "切換密鑰顯示",
          "RESET_SUCCESS": "Webhook 密鑰已成功重新產生",
          "RESET_ERROR": "無法重新產生 Webhook 密鑰，請再試一次"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "網站網域",
          "PLACEHOLDER": "輸入您的網站網域（例：acme.com）"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "歡迎標題",
          "PLACEHOLDER": "您好！"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "歡迎副標題",
          "PLACEHOLDER": "我們讓溝通變得簡單。歡迎提出任何問題，或分享您的意見。"
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "頻道問候訊息",
          "PLACEHOLDER": "Acme Inc 通常在幾小時內回覆。"
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "啟用頻道問候功能",
          "HELP_TEXT": "當客戶發起對話並發送第一則訊息時，自動發送問候訊息。",
          "ENABLED": "已啟用",
          "DISABLED": "已停用"
        },
        "REPLY_TIME": {
          "TITLE": "設定回覆時間",
          "IN_A_FEW_MINUTES": "幾分鐘內",
          "IN_A_FEW_HOURS": "幾小時內",
          "IN_A_DAY": "一天內",
          "HELP_TEXT": "此回覆時間將顯示在即時聊天小工具上"
        },
        "WIDGET_COLOR": {
          "LABEL": "小工具顏色",
          "PLACEHOLDER": "更新小工具使用的顏色"
        },
        "SUBMIT_BUTTON": "建立收件匣",
        "API": {
          "ERROR_MESSAGE": "無法建立網站頻道，請重試"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp 頻道",
        "DESC": "整合 Twilio，透過 SMS 或 WhatsApp 為客戶提供支援服務。",
        "ACCOUNT_SID": {
          "LABEL": "帳戶 SID",
          "PLACEHOLDER": "請輸入您的 Twilio 帳戶 SID",
          "ERROR": "此欄位為必填"
        },
        "API_KEY": {
          "USE_API_KEY": "使用 API Key 驗證",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "請輸入您的 API Key SID",
          "ERROR": "此欄位為必填"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "請輸入您的 API Key Secret",
          "ERROR": "此欄位為必填"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging Service SID",
          "PLACEHOLDER": "請輸入您的 Twilio Messaging Service SID",
          "ERROR": "此欄位為必填",
          "USE_MESSAGING_SERVICE": "使用 Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "頻道類型",
          "ERROR": "請選擇您的頻道類型"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "請輸入您的 Twilio Auth Token",
          "ERROR": "此欄位為必填"
        },
        "CHANNEL_NAME": {
          "LABEL": "收件匣名稱",
          "PLACEHOLDER": "請輸入收件匣名稱",
          "ERROR": "此欄位為必填"
        },
        "PHONE_NUMBER": {
          "LABEL": "電話號碼",
          "PLACEHOLDER": "請輸入發送訊息的電話號碼。",
          "ERROR": "請提供以 `+` 開頭且不含空格的有效電話號碼。"
        },
        "API_CALLBACK": {
          "TITLE": "回呼 URL",
          "SUBTITLE": "您需要在 Twilio 中使用此處的 URL 設定訊息回呼 URL。"
        },
        "SUBMIT_BUTTON": "建立 Twilio 頻道",
        "API": {
          "ERROR_MESSAGE": "無法驗證 Twilio 憑證，請重試"
        }
      },
      "SMS": {
        "TITLE": "SMS 頻道",
        "DESC": "透過 SMS 開始為客戶提供支援服務。",
        "PROVIDERS": {
          "LABEL": "API 供應商",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth"
        },
        "API": {
          "ERROR_MESSAGE": "無法儲存 SMS 頻道"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "帳戶 ID",
            "PLACEHOLDER": "請輸入您的 Bandwidth 帳戶 ID",
            "ERROR": "此欄位為必填"
          },
          "API_KEY": {
            "LABEL": "API Key",
            "PLACEHOLDER": "請輸入您的 Bandwidth API Key",
            "ERROR": "此欄位為必填"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "請輸入您的 Bandwidth API Secret",
            "ERROR": "此欄位為必填"
          },
          "APPLICATION_ID": {
            "LABEL": "Application ID",
            "PLACEHOLDER": "請輸入您的 Bandwidth Application ID",
            "ERROR": "此欄位為必填"
          },
          "INBOX_NAME": {
            "LABEL": "收件匣名稱",
            "PLACEHOLDER": "請輸入收件匣名稱",
            "ERROR": "此欄位為必填"
          },
          "PHONE_NUMBER": {
            "LABEL": "電話號碼",
            "PLACEHOLDER": "請輸入發送訊息的電話號碼。",
            "ERROR": "請提供以 `+` 開頭且不含空格的有效電話號碼。"
          },
          "SUBMIT_BUTTON": "建立 Bandwidth 頻道",
          "API": {
            "ERROR_MESSAGE": "無法驗證 Bandwidth 憑證，請重試"
          },
          "API_CALLBACK": {
            "TITLE": "回呼 URL",
            "SUBTITLE": "您需要在 Bandwidth 中使用此處的 URL 設定訊息回呼 URL。"
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "WhatsApp 頻道",
        "DESC": "透過 WhatsApp 開始為客戶提供支援服務。",
        "PROVIDERS": {
          "LABEL": "API 供應商",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "WhatsApp Cloud",
          "WHATSAPP_CLOUD_DESC": "透過 Meta 快速設定",
          "TWILIO_DESC": "透過 Twilio 憑證連接",
          "360_DIALOG": "360Dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "選擇您的 API 供應商",
          "DESCRIPTION": "選擇您的 WhatsApp 供應商。您可以透過 Meta 直接連接（無需額外設定），或使用 Twilio 帳戶憑證連接。"
        },
        "INBOX_NAME": {
          "LABEL": "收件匣名稱",
          "PLACEHOLDER": "請輸入收件匣名稱",
          "ERROR": "此欄位為必填"
        },
        "PHONE_NUMBER": {
          "LABEL": "電話號碼",
          "PLACEHOLDER": "請輸入發送訊息的電話號碼。",
          "ERROR": "請提供以 `+` 開頭且不含空格的有效電話號碼。"
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "電話號碼 ID",
          "PLACEHOLDER": "請輸入從 Facebook 開發者後台取得的電話號碼 ID。",
          "ERROR": "請輸入有效的值。"
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "商業帳戶 ID",
          "PLACEHOLDER": "請輸入從 Facebook 開發者後台取得的商業帳戶 ID。",
          "ERROR": "請輸入有效的值。"
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "Webhook 驗證 Token",
          "PLACEHOLDER": "輸入您想為 Facebook Webhook 設定的驗證 Token。",
          "ERROR": "請輸入有效的值。"
        },
        "API_KEY": {
          "LABEL": "API Key",
          "SUBTITLE": "設定 WhatsApp API Key。",
          "PLACEHOLDER": "API Key",
          "ERROR": "請輸入有效的值。"
        },
        "API_CALLBACK": {
          "TITLE": "回呼 URL",
          "SUBTITLE": "您需要在 Facebook 開發者入口網站中，使用下方顯示的值設定 Webhook URL 和驗證 Token。",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook 驗證 Token"
        },
        "SUBMIT_BUTTON": "建立 WhatsApp 頻道",
        "EMBEDDED_SIGNUP": {
          "TITLE": "透過 Meta 快速設定",
          "DESC": "使用 WhatsApp Embedded Signup 流程快速連接新號碼。您將被導向至 Meta 登入 WhatsApp Business 帳號。擁有管理員權限將有助於順利完成設定。",
          "BENEFITS": {
            "TITLE": "Embedded Signup 的優點：",
            "EASY_SETUP": "無需手動設定",
            "SECURE_AUTH": "安全的 OAuth 驗證",
            "AUTO_CONFIG": "自動設定 Webhook 和電話號碼"
          },
          "LEARN_MORE": {
            "TEXT": "如需了解更多關於整合註冊、定價和限制的資訊，請造訪 {link}。",
            "LINK_TEXT": "此連結"
          },
          "SUBMIT_BUTTON": "連接 WhatsApp Business",
          "AUTH_PROCESSING": "正在透過 Meta 進行驗證",
          "WAITING_FOR_BUSINESS_INFO": "請在 Meta 視窗中完成商業設定...",
          "PROCESSING": "正在設定您的 WhatsApp Business 帳號",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "正在載入 Facebook SDK...",
          "CANCELLED": "WhatsApp 註冊已取消",
          "SUCCESS_TITLE": "WhatsApp Business 帳號已連接！",
          "WAITING_FOR_AUTH": "正在等待驗證...",
          "INVALID_BUSINESS_DATA": "從 Facebook 收到的商業資料無效。請重試。",
          "SIGNUP_ERROR": "註冊時發生錯誤",
          "AUTH_NOT_COMPLETED": "驗證未完成。請重新開始流程。",
          "SUCCESS_FALLBACK": "WhatsApp Business 帳號已成功設定",
          "MANUAL_FALLBACK": "如果您的號碼已連接到 WhatsApp Business Platform（API），或者您是正在接入自己號碼的技術供應商，請使用 {link}",
          "MANUAL_LINK_TEXT": "手動設定流程",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "無法儲存 WhatsApp 頻道"
        }
      },
      "VOICE": {
        "TITLE": "語音頻道",
        "DESC": "整合 Twilio Voice，透過電話為客戶提供支援服務。",
        "PHONE_NUMBER": {
          "LABEL": "電話號碼",
          "PLACEHOLDER": "輸入您的電話號碼（例：+1234567890）",
          "ERROR": "請提供 E.164 格式的有效電話號碼（例：+1234567890）"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "帳戶 SID",
            "PLACEHOLDER": "輸入您的 Twilio 帳戶 SID",
            "REQUIRED": "帳戶 SID 為必填"
          },
          "AUTH_TOKEN": {
            "LABEL": "Auth Token",
            "PLACEHOLDER": "輸入您的 Twilio Auth Token",
            "REQUIRED": "Auth Token 為必填"
          },
          "API_KEY_SID": {
            "LABEL": "API Key SID",
            "PLACEHOLDER": "輸入您的 Twilio API Key SID",
            "REQUIRED": "API Key SID 為必填"
          },
          "API_KEY_SECRET": {
            "LABEL": "API Key Secret",
            "PLACEHOLDER": "輸入您的 Twilio API Key Secret",
            "REQUIRED": "API Key Secret 為必填"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "在您的 Twilio 電話號碼和 TwiML App 上將此 URL 設定為 Voice URL。",
          "TWILIO_STATUS_URL_TITLE": "Twilio Status Callback URL",
          "TWILIO_STATUS_URL_SUBTITLE": "在您的 Twilio 電話號碼上將此 URL 設定為 Status Callback URL。"
        },
        "SUBMIT_BUTTON": "建立語音頻道",
        "API": {
          "ERROR_MESSAGE": "無法建立語音頻道"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API 頻道",
        "DESC": "整合 API 頻道，開始為客戶提供支援服務。",
        "CHANNEL_NAME": {
          "LABEL": "頻道名稱",
          "PLACEHOLDER": "請輸入頻道名稱",
          "ERROR": "此欄位為必填"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "設定您想要接收事件回呼的 URL。",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "建立 API 頻道",
        "API": {
          "ERROR_MESSAGE": "無法儲存 API 頻道"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "電子郵件頻道",
        "DESC": "整合您的電子郵件信箱。",
        "CHANNEL_NAME": {
          "LABEL": "頻道名稱",
          "PLACEHOLDER": "請輸入頻道名稱",
          "ERROR": "此欄位為必填"
        },
        "EMAIL": {
          "LABEL": "Email",
          "SUBTITLE": "請提供客戶發送支援請求的電子郵件地址。",
          "PLACEHOLDER": "Email"
        },
        "SUBMIT_BUTTON": "建立電子郵件頻道",
        "API": {
          "ERROR_MESSAGE": "無法儲存電子郵件頻道"
        },
        "FINISH_MESSAGE": "您的電子郵件收件匣已成功建立！您可以開始將郵件轉寄至下方地址，或設定 SMTP 和 IMAP 憑證以直接收發郵件。",
        "FINISH_MESSAGE_NO_FORWARDING": "您的電子郵件收件匣已成功建立！您需要設定 SMTP 和 IMAP 憑證才能收發郵件。若未設定，將不會處理任何郵件。",
        "FORWARDING_ADDRESS_LABEL": "將郵件轉寄至此地址：",
        "CONFIGURE_SMTP_IMAP_LINK": "點擊這裡",
        "CONFIGURE_SMTP_IMAP_TEXT": "設定 IMAP 和 SMTP"
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE 頻道",
        "DESC": "整合 LINE 頻道，開始為客戶提供支援服務。",
        "CHANNEL_NAME": {
          "LABEL": "頻道名稱",
          "PLACEHOLDER": "請輸入頻道名稱",
          "ERROR": "此欄位為必填"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Channel ID",
          "PLACEHOLDER": "LINE Channel ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Channel Secret",
          "PLACEHOLDER": "LINE Channel Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Channel Token",
          "PLACEHOLDER": "LINE Channel Token"
        },
        "SUBMIT_BUTTON": "建立 LINE 頻道",
        "API": {
          "ERROR_MESSAGE": "無法儲存 LINE 頻道"
        },
        "API_CALLBACK": {
          "TITLE": "回呼 URL",
          "SUBTITLE": "您需要在 LINE 應用程式中使用此處的 URL 設定 Webhook URL。"
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram 頻道",
        "DESC": "整合 Telegram 頻道，開始為客戶提供支援服務。",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "設定您從 Telegram BotFather 取得的 Bot Token。",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "建立 Telegram 頻道",
        "API": {
          "ERROR_MESSAGE": "無法儲存 Telegram 頻道"
        }
      },
      "AUTH": {
        "TITLE": "選擇頻道",
        "DESC": "Chatwoot 支援即時聊天小工具、Facebook Messenger、WhatsApp、電子郵件等頻道。如果您想建立自訂頻道，可以使用 API 頻道來建立。請選擇以下其中一個頻道開始使用。",
        "TITLE_NEXT": "完成設定",
        "TITLE_FINISH": "完成！",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "網站",
            "DESCRIPTION": "建立即時聊天小工具"
          },
          "FACEBOOK": {
            "TITLE": "Facebook",
            "DESCRIPTION": "連結您的 Facebook 粉絲專頁"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "透過 WhatsApp 為客戶提供支援"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "Email",
            "DESCRIPTION": "連結 Gmail、Outlook 或其他供應商"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "透過 Twilio 或 Bandwidth 整合 SMS 頻道"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "使用我們的 API 建立自訂頻道"
          },
          "TELEGRAM": {
            "TITLE": "Telegram",
            "DESCRIPTION": "使用 Bot Token 設定 Telegram 頻道"
          },
          "LINE": {
            "TITLE": "LINE",
            "DESCRIPTION": "整合您的 LINE 頻道"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "連結您的 Instagram 帳號"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "連結您的 TikTok 帳號"
          },
          "VOICE": {
            "TITLE": "語音",
            "DESCRIPTION": "整合 Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "客服人員",
        "DESC": "在此您可以新增客服人員來管理新建立的收件匣。只有被選取的客服人員才能存取此收件匣。不屬於此收件匣的客服人員在登入後將無法查看或回覆此收件匣中的訊息。<br> <b>注意：</b>身為管理員，如果您需要存取所有收件匣，應將自己新增為所有收件匣的客服人員。",
        "VALIDATION_ERROR": "請至少新增一位客服人員到新收件匣",
        "PICK_AGENTS": "為收件匣選擇客服人員"
      },
      "DETAILS": {
        "TITLE": "收件匣詳情",
        "DESC": "從下方的下拉選單中選擇您要連結至 Chatwoot 的 Facebook 粉絲專頁。您也可以為收件匣設定自訂名稱以便識別。"
      },
      "FINISH": {
        "TITLE": "完成！",
        "DESC": "您已成功將 Facebook 粉絲專頁與 Chatwoot 整合。下次客戶在您的粉絲專頁發送訊息時，對話將自動出現在收件匣中。<br>我們也為您提供了一段小工具程式碼，您可以輕鬆地加入到您的網站中。網站上線後，客戶可以直接從您的網站傳送訊息給您，無需任何外部工具，對話將直接顯示在 Chatwoot 中。<br>很酷吧？我們一直在努力 :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "選擇您的電子郵件供應商",
        "DESCRIPTION": "從下方列表中選擇一個電子郵件供應商。如果列表中沒有您的供應商，可以選擇其他供應商選項，並提供 IMAP 和 SMTP 憑證。"
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "點擊「使用 Microsoft 登入」按鈕開始。您將被導向至電子郵件登入頁面。接受所需權限後，將返回收件匣建立步驟。",
        "EMAIL_PLACEHOLDER": "輸入電子郵件地址",
        "SIGN_IN": "使用 Microsoft 登入",
        "ERROR_MESSAGE": "連結 Microsoft 時發生錯誤，請重試"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "點擊「使用 Google 登入」按鈕開始。您將被導向至電子郵件登入頁面。接受所需權限後，將返回收件匣建立步驟。",
        "SIGN_IN": "使用 Google 登入",
        "EMAIL_PLACEHOLDER": "輸入電子郵件地址",
        "ERROR_MESSAGE": "連結 Google 時發生錯誤，請重試"
      }
    },
    "DETAILS": {
      "LOADING_FB": "正在透過 Facebook 進行驗證...",
      "ERROR_FB_LOADING": "載入 Facebook SDK 時發生錯誤。請停用廣告攔截器，並使用其他瀏覽器重試。",
      "ERROR_FB_AUTH": "發生錯誤，請重新整理頁面...",
      "ERROR_FB_UNAUTHORIZED": "您未獲授權執行此操作。",
      "ERROR_FB_UNAUTHORIZED_HELP": "請確認您擁有 Facebook 粉絲專頁的完整控制權限。您可以在<a href=\" https://www.facebook.com/help/187316341316631\">此處</a>了解更多 Facebook 角色的相關資訊。",
      "CREATING_CHANNEL": "正在建立您的收件匣...",
      "TITLE": "設定收件匣詳情",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "新增客服人員",
      "ADD_AGENTS": "正在將客服人員新增到您的收件匣..."
    },
    "FINISH": {
      "TITLE": "您的收件匣已準備就緒！",
      "MESSAGE": "您現在可以透過新頻道與客戶互動。祝您支援愉快！",
      "BUTTON_TEXT": "前往收件匣",
      "MORE_SETTINGS": "更多設定",
      "WEBSITE_SUCCESS": "您已成功建立網站頻道。複製下方顯示的程式碼，並貼到您的網站上。下次客戶使用即時聊天時，對話將自動出現在您的收件匣中。",
      "WHATSAPP_QR_INSTRUCTION": "掃描上方 QR Code 以快速測試您的 WhatsApp 收件匣",
      "MESSENGER_QR_INSTRUCTION": "掃描上方 QR Code 以快速測試您的 Facebook Messenger 收件匣",
      "TELEGRAM_QR_INSTRUCTION": "掃描上方 QR Code 以快速測試您的 Telegram 收件匣"
    },
    "REAUTH": "重新授權",
    "VIEW": "查看",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "已成功更新收件匣設定",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "自動分配已成功更新",
        "ERROR_MESSAGE": "無法更新收件匣設定，請稍後再試。"
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "已啟用",
        "DISABLED": "已停用"
      },
      "ENABLE_CSAT": {
        "ENABLED": "已啟用",
        "DISABLED": "已停用"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "寄件者名稱",
        "SUB_TEXT": "選擇客戶收到客服人員郵件時顯示的名稱。",
        "FOR_EG": "例如：",
        "FRIENDLY": {
          "TITLE": "親切風格",
          "FROM": "來自",
          "SUBTITLE": "在寄件者名稱中加入回覆客服人員的姓名，使其更加親切。"
        },
        "PROFESSIONAL": {
          "TITLE": "專業風格",
          "SUBTITLE": "僅使用已設定的企業名稱作為電子郵件標頭中的寄件者名稱。"
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "設定您的企業名稱",
          "PLACEHOLDER": "輸入您的企業名稱",
          "SAVE_BUTTON_TEXT": "儲存"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "已啟用",
        "DISABLED": "已停用"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "已啟用",
        "DISABLED": "已停用"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "重新開啟同一對話",
        "DISABLED": "建立新對話",
        "ENABLED_DESCRIPTION": "當聯絡人再次傳送訊息時，將重新開啟先前的對話。",
        "DISABLED_DESCRIPTION": "前一次對話解決後，每次都會建立新的對話。"
      },
      "ENABLE_HMAC": {
        "LABEL": "啟用"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "刪除",
      "AVATAR_DELETE_BUTTON_TEXT": "刪除頭像",
      "CONFIRM": {
        "TITLE": "確認刪除",
        "MESSAGE": "您確定要刪除嗎？",
        "PLACE_HOLDER": "請輸入 {inboxName} 以確認",
        "YES": "是，刪除",
        "NO": "否，保留"
      },
      "API": {
        "SUCCESS_MESSAGE": "收件匣已成功刪除",
        "ERROR_MESSAGE": "無法刪除收件匣，請稍後再試。",
        "AVATAR_SUCCESS_MESSAGE": "收件匣頭像已成功刪除",
        "AVATAR_ERROR_MESSAGE": "無法刪除收件匣頭像，請稍後再試。"
      }
    },
    "TABS": {
      "SETTINGS": "設定",
      "COLLABORATORS": "協作人員",
      "CONFIGURATION": "設定檔",
      "CAMPAIGN": "行銷活動",
      "PRE_CHAT_FORM": "聊天前表單",
      "BUSINESS_HOURS": "服務時間",
      "WIDGET_BUILDER": "小工具建置器",
      "BOT_CONFIGURATION": "機器人設定",
      "ACCOUNT_HEALTH": "帳號健康狀態",
      "CSAT": "CSAT",
      "VOICE": "語音",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "頻道偏好設定",
    "WIDGET_FEATURES": "小工具功能",
    "ACCOUNT_HEALTH": {
      "TITLE": "管理您的 WhatsApp 帳號",
      "DESCRIPTION": "檢視您的 WhatsApp 帳號狀態、訊息限制和品質。如有需要，更新設定或解決問題。",
      "GO_TO_SETTINGS": "前往 Meta Business Manager",
      "NO_DATA": "無法取得健康狀態資料",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "顯示電話號碼",
          "TOOLTIP": "顯示給客戶的電話號碼"
        },
        "VERIFIED_NAME": {
          "LABEL": "企業名稱",
          "TOOLTIP": "經 WhatsApp 驗證的企業名稱"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "顯示名稱狀態",
          "TOOLTIP": "您的企業名稱驗證狀態"
        },
        "QUALITY_RATING": {
          "LABEL": "品質評分",
          "TOOLTIP": "您帳號的 WhatsApp 品質評分"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "訊息限制等級",
          "TOOLTIP": "您帳號的每日訊息限制"
        },
        "ACCOUNT_MODE": {
          "LABEL": "帳號模式",
          "TOOLTIP": "您的 WhatsApp 帳號目前的運作模式"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "每 24 小時 250 位客戶",
          "TIER_1000": "每 24 小時 1K 位客戶",
          "TIER_1K": "每 24 小時 1K 位客戶",
          "TIER_10K": "每 24 小時 10K 位客戶",
          "TIER_100K": "每 24 小時 100K 位客戶",
          "TIER_UNLIMITED": "每 24 小時不限客戶數",
          "UNKNOWN": "評分不可用"
        },
        "STATUSES": {
          "APPROVED": "已核准",
          "PENDING_REVIEW": "審核中",
          "AVAILABLE_WITHOUT_REVIEW": "無需審核即可使用",
          "REJECTED": "已拒絕",
          "DECLINED": "已駁回",
          "NON_EXISTS": "不存在"
        },
        "MODES": {
          "SANDBOX": "沙箱模式",
          "LIVE": "正式環境"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook 設定",
        "DESCRIPTION": "您的 WhatsApp Business 帳號需要設定 Webhook URL，才能接收客戶訊息",
        "ACTION_REQUIRED": "Webhook 尚未設定",
        "REGISTER_BUTTON": "註冊 Webhook",
        "REGISTER_SUCCESS": "Webhook 註冊成功",
        "REGISTER_ERROR": "Webhook 註冊失敗，請再試一次。",
        "CONFIGURED_SUCCESS": "Webhook 設定成功",
        "URL_MISMATCH": "Webhook URL 不符"
      }
    },
    "SETTINGS": "設定",
    "FEATURES": {
      "LABEL": "功能",
      "DISPLAY_FILE_PICKER": "在小工具上顯示檔案選擇器",
      "DISPLAY_EMOJI_PICKER": "在小工具上顯示表情符號選擇器",
      "ALLOW_END_CONVERSATION": "允許使用者從小工具結束對話",
      "USE_INBOX_AVATAR_FOR_BOT": "使用收件匣名稱和頭像作為機器人顯示"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger 程式碼",
      "MESSENGER_SUB_HEAD": "將此按鈕放置在 body 標籤中",
      "ALLOWED_DOMAINS": {
        "TITLE": "允許的網域",
        "DESCRIPTION": "限制哪些網站可以嵌入您的聊天小工具。為了安全起見，請僅新增您擁有且信任的網域。輸入一個或多個網域，以逗號分隔。留空則允許所有網域（不建議在正式環境中使用）。",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "在行動應用程式中啟用小工具",
        "SUBTITLE": "如果您將小工具嵌入 iOS 或 Android 應用程式，請勾選此項。行動應用程式不會發送網域資訊，因此除非啟用此選項，否則會被網域限制封鎖。"
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "身份驗證",
        "DESCRIPTION": "透過產生安全 Token 來驗證使用者身份。這可以防止未授權使用者在您的聊天中冒充他人。",
        "SECRET_KEY": "密鑰",
        "VIEW_DOCS": "查看文件",
        "REQUIRE_LABEL": "要求所有對話進行身份驗證",
        "REQUIRE_DESCRIPTION": "啟用後，使用者必須提供有效的身份 Token 才能開始對話。未提供有效 Token 的請求將被拒絕。"
      },
      "INBOX_AGENTS": "客服人員",
      "INBOX_AGENTS_SUB_TEXT": "新增或移除此收件匣中的客服人員",
      "AGENT_ASSIGNMENT": "對話分配",
      "AGENT_ASSIGNMENT_SUB_TEXT": "更新對話分配設定",
      "UPDATE": "更新",
      "ENABLE_EMAIL_COLLECT_BOX": "啟用電子郵件收集框",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "在新對話中啟用或停用電子郵件收集框",
      "AUTO_ASSIGNMENT": "啟用自動分配",
      "SENDER_NAME_SECTION": "在郵件中啟用客服人員名稱",
      "SENDER_NAME_SECTION_TEXT": "啟用/停用在郵件中顯示客服人員名稱，停用時將顯示企業名稱",
      "ENABLE_CONTINUITY_VIA_EMAIL": "透過電子郵件啟用對話延續",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "若聯絡人有電子郵件地址，對話將透過電子郵件繼續。",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "對話路由",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "設定現有聯絡人的對話建立方式",
      "INBOX_UPDATE_TITLE": "收件匣設定",
      "INBOX_UPDATE_SUB_TEXT": "更新您的收件匣設定",
      "AUTO_ASSIGNMENT_SUB_TEXT": "啟用或停用此收件匣客服人員的新對話自動分配。",
      "HMAC_VERIFICATION": "使用者身份驗證",
      "HMAC_DESCRIPTION": "使用此金鑰，您可以產生用於驗證使用者身份的安全 Token。",
      "HMAC_LINK_TO_DOCS": "您可以在此了解更多。",
      "HMAC_MANDATORY_VERIFICATION": "強制使用者身份驗證",
      "HMAC_MANDATORY_DESCRIPTION": "啟用後，無法驗證的請求將被拒絕。",
      "INBOX_IDENTIFIER": "收件匣識別碼",
      "INBOX_IDENTIFIER_SUB_TEXT": "使用此處顯示的 `inbox_identifier` Token 來驗證您的 API 用戶端。",
      "FORWARD_EMAIL_TITLE": "轉寄電子郵件",
      "FORWARD_EMAIL_SUB_TEXT": "開始將您的電子郵件轉寄至以下地址。",
      "FORWARD_EMAIL_NOT_CONFIGURED": "此安裝環境目前未啟用郵件轉寄功能。若需使用此功能，請聯絡您的管理員啟用。",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "允許在對話解決後傳送訊息",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "允許終端使用者在對話已解決後仍能傳送訊息。",
      "WHATSAPP_SECTION_SUBHEADER": "此 API Key 用於與 WhatsApp API 的整合。",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "輸入用於 WhatsApp API 整合的新 API Key。",
      "WHATSAPP_SECTION_TITLE": "API Key",
      "WHATSAPP_SECTION_UPDATE_TITLE": "更新 API Key",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "在此輸入新的 API Key",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "更新",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp Embedded Signup",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "此收件匣透過 WhatsApp Embedded Signup 連接。",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "您可以重新設定此收件匣以更新 WhatsApp Business 設定。",
      "WHATSAPP_RECONFIGURE_BUTTON": "重新設定",
      "WHATSAPP_CONNECT_TITLE": "連接到 WhatsApp Business",
      "WHATSAPP_CONNECT_SUBHEADER": "升級至 WhatsApp Embedded Signup 以便於管理。",
      "WHATSAPP_CONNECT_DESCRIPTION": "將此收件匣連接到 WhatsApp Business，以獲得進階功能和更便捷的管理。",
      "WHATSAPP_CONNECT_BUTTON": "連接",
      "WHATSAPP_CONNECT_SUCCESS": "已成功連接到 WhatsApp Business！",
      "WHATSAPP_CONNECT_ERROR": "連接 WhatsApp Business 失敗，請重試。",
      "WHATSAPP_RECONFIGURE_SUCCESS": "已成功重新設定 WhatsApp Business！",
      "WHATSAPP_RECONFIGURE_ERROR": "重新設定 WhatsApp Business 失敗，請重試。",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID 尚未設定，請聯絡您的管理員。",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID 尚未設定，請聯絡您的管理員。",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp 登入已取消，請重試。",
      "WHATSAPP_WEBHOOK_TITLE": "Webhook 驗證 Token",
      "WHATSAPP_WEBHOOK_SUBHEADER": "此 Token 用於驗證 Webhook 端點的真實性。",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "同步範本",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "手動從 WhatsApp 同步訊息範本以更新可用範本。",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "同步範本",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "範本同步已啟動。可能需要幾分鐘才能更新完成。",
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "更新聊天前表單設定"
    },
    "HELP_CENTER": {
      "LABEL": "幫助中心",
      "PLACEHOLDER": "選擇幫助中心",
      "SELECT_PLACEHOLDER": "選擇幫助中心",
      "NONE": "無",
      "REMOVE": "移除幫助中心",
      "SUB_TEXT": "將幫助中心連結到此收件匣"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "自動分配上限",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "請輸入大於 0 的值",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "限制此收件匣可自動分配給單一客服人員的最大對話數"
    },
    "ASSIGNMENT": {
      "TITLE": "對話分配",
      "DESCRIPTION": "根據分配策略，自動將新對話分配給可用的客服人員",
      "ENABLE_AUTO_ASSIGNMENT": "啟用自動對話分配",
      "DEFAULT_RULES_TITLE": "預設分配規則",
      "DEFAULT_RULES_DESCRIPTION": "對所有對話使用預設分配行為",
      "DEFAULT_RULE_1": "優先處理最早建立的對話",
      "DEFAULT_RULE_2": "輪流分配",
      "CUSTOMIZE_WITH_POLICY": "使用分配策略自訂",
      "USING_POLICY": "此收件匣使用自訂分配策略",
      "CUSTOMIZE_POLICY": "使用分配策略自訂",
      "DELETE_POLICY": "刪除策略",
      "POLICY_LABEL": "分配策略",
      "ASSIGNMENT_ORDER_LABEL": "分配順序",
      "ASSIGNMENT_METHOD_LABEL": "分配方式",
      "POLICY_STATUS": {
        "ACTIVE": "啟用中",
        "INACTIVE": "已停用"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "最早建立",
        "LONGEST_WAITING": "等待最久"
      },
      "METHOD": {
        "ROUND_ROBIN": "輪流分配",
        "BALANCED": "均衡分配"
      },
      "UPGRADE_PROMPT": "自訂分配策略適用於 Business 方案",
      "UPGRADE_TO_BUSINESS": "升級至 Business",
      "DEFAULT_POLICY_LINKED": "已連結預設策略",
      "DEFAULT_POLICY_DESCRIPTION": "連結自訂分配策略，以自訂此收件匣中對話分配給客服人員的方式。",
      "LINK_EXISTING_POLICY": "連結現有策略",
      "CREATE_NEW_POLICY": "建立新策略",
      "NO_POLICIES": "找不到分配策略",
      "VIEW_ALL_POLICIES": "查看所有策略",
      "CURRENT_BEHAVIOR": "目前使用預設分配行為：",
      "LINK_SUCCESS": "已成功連結分配策略",
      "LINK_ERROR": "連結分配策略失敗"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "要刪除分配策略嗎？",
      "DELETE_CONFIRM_MESSAGE": "您確定要從此收件匣移除此分配策略嗎？收件匣將恢復為預設分配規則。",
      "CANCEL": "取消",
      "CONFIRM_DELETE": "刪除",
      "DELETE_SUCCESS": "已成功移除分配策略",
      "DELETE_ERROR": "移除分配策略失敗"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "重新授權",
      "SUBTITLE": "您的 Facebook 連線已過期，請重新連結 Facebook 粉絲專頁以繼續服務",
      "MESSAGE_SUCCESS": "重新連線成功",
      "MESSAGE_ERROR": "發生錯誤，請重試"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "聊天前表單可讓您在客戶開始對話之前收集其資訊。",
      "SET_FIELDS": "聊天前表單欄位",
      "SET_FIELDS_HEADER": {
        "FIELDS": "欄位",
        "LABEL": "標籤",
        "PLACE_HOLDER": "預設文字",
        "KEY": "鍵值",
        "TYPE": "類型",
        "REQUIRED": "必填"
      },
      "ENABLE": {
        "LABEL": "啟用聊天前表單",
        "OPTIONS": {
          "ENABLED": "是",
          "DISABLED": "否"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "聊天前訊息",
        "PLACEHOLDER": "此訊息將與表單一起顯示給使用者"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "訪客在開始聊天前須提供姓名和電子郵件地址"
      }
    },
    "CSAT": {
      "TITLE": "啟用 CSAT",
      "SUBTITLE": "在對話結束時自動觸發 CSAT 滿意度調查，了解客戶對支援體驗的感受。追蹤滿意度趨勢，找出需要改善的地方。",
      "DISPLAY_TYPE": {
        "LABEL": "顯示類型"
      },
      "MESSAGE": {
        "LABEL": "訊息",
        "PLACEHOLDER": "請輸入要與表單一起顯示給使用者的訊息"
      },
      "BUTTON_TEXT": {
        "LABEL": "按鈕文字",
        "PLACEHOLDER": "請為我們評分"
      },
      "LANGUAGE": {
        "LABEL": "語言",
        "PLACEHOLDER": "選擇範本語言"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "訊息預覽",
        "TOOLTIP": "在 WhatsApp 平台上呈現時可能會略有不同。"
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "已獲 WhatsApp 核准",
        "PENDING": "待 WhatsApp 審核中",
        "REJECTED": "Meta 已拒絕此範本",
        "DEFAULT": "需要 WhatsApp 審核",
        "NOT_FOUND": "此範本在 Meta 平台上不存在。"
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp 範本已成功建立並送出審核",
        "ERROR_MESSAGE": "建立 WhatsApp 範本失敗"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "編輯問卷調查詳情",
        "DESCRIPTION": "我們將刪除先前的範本並建立新範本，新範本將再次送交 WhatsApp 審核",
        "CONFIRM": "建立新範本",
        "CANCEL": "返回"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "檢查 Utility 適配性",
        "HELPER_NOTE": "在送出前檢查此訊息以改善 Utility 適配性。系統會建立包含報告按鈕的專用 CSAT 範本，並以 Utility 類型送出；Meta 仍可能根據內容將其重新分類為 Marketing。",
        "RESULT_LABEL": "Meta 分類預測",
        "GUIDANCE_NOTE": "這是指引性檢查，不保證 Meta 一定會核准。",
        "SUGGESTION_LABEL": "建議的 Utility 安全改寫",
        "APPLY": "使用此改寫",
        "ERROR_MESSAGE": "無法分析訊息，請重試。",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "可能為 Utility",
          "LIKELY_MARKETING": "可能為 Marketing",
          "UNCLEAR": "需要進一步釐清"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "問卷規則",
        "DESCRIPTION_PREFIX": "在對話",
        "DESCRIPTION_SUFFIX": "任一標籤時發送問卷",
        "OPERATOR": {
          "CONTAINS": "包含",
          "DOES_NOT_CONTAINS": "不包含"
        },
        "SELECT_PLACEHOLDER": "選擇標籤"
      },
      "NOTE": "注意：CSAT 問卷每次對話僅發送一次",
      "WHATSAPP_NOTE": "注意：儲存後，系統會在 WhatsApp 中建立專用的 CSAT 範本（用於在報告中收集評分和回饋），並以 Utility 類型送出審核。Meta 仍可能根據內容將其分類為 Marketing。核准後，問卷將依據問卷規則，每次對話僅發送一次。",
      "API": {
        "SUCCESS_MESSAGE": "CSAT 設定已成功更新",
        "ERROR_MESSAGE": "無法更新 CSAT 設定，請稍後再試。"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "設定您的服務時間",
      "SUBTITLE": "在即時聊天小工具上設定您的服務時間",
      "WEEKLY_TITLE": "設定每週服務時間",
      "TIMEZONE_LABEL": "選擇時區",
      "UPDATE": "更新服務時間設定",
      "TOGGLE_AVAILABILITY": "啟用此收件匣的服務時間",
      "UNAVAILABLE_MESSAGE_LABEL": "訪客不可用時的訊息",
      "TOGGLE_HELP": "啟用服務時間後，即使所有客服人員都離線，也會在即時聊天小工具上顯示可用時間。在非服務時間，訪客將會看到提示訊息和聊天前表單。",
      "DAY": {
        "DAY": "日",
        "AVAILABILITY": "服務狀態",
        "HOURS": "時間",
        "ENABLE": "啟用此日的服務時間",
        "UNAVAILABLE": "不可用",
        "VALIDATION_ERROR": "開始時間必須早於結束時間。",
        "CHOOSE": "選擇"
      },
      "ALL_DAY": "全天"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "設定您的 IMAP 資訊",
      "NOTE_TEXT": "若要啟用 SMTP，請先設定 IMAP。",
      "UPDATE": "更新 IMAP 設定",
      "TOGGLE_AVAILABILITY": "為此收件匣啟用 IMAP 設定",
      "TOGGLE_HELP": "啟用 IMAP 將可接收電子郵件",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP 設定已成功更新",
        "ERROR_MESSAGE": "無法更新 IMAP 設定"
      },
      "ADDRESS": {
        "LABEL": "位址",
        "PLACE_HOLDER": "位址（例：imap.gmail.com）"
      },
      "PORT": {
        "LABEL": "連接埠",
        "PLACE_HOLDER": "連接埠"
      },
      "LOGIN": {
        "LABEL": "登入帳號",
        "PLACE_HOLDER": "登入帳號"
      },
      "PASSWORD": {
        "LABEL": "密碼",
        "PLACE_HOLDER": "密碼"
      },
      "ENABLE_SSL": "啟用 SSL",
      "AUTH_MECHANISM": "驗證機制"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "重新授權您的 Microsoft 帳號"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "設定您的 SMTP 資訊",
      "UPDATE": "更新 SMTP 設定",
      "TOGGLE_AVAILABILITY": "為此收件匣啟用 SMTP 設定",
      "TOGGLE_HELP": "啟用 SMTP 將可發送電子郵件",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP 設定已成功更新",
        "ERROR_MESSAGE": "無法更新 SMTP 設定"
      },
      "ADDRESS": {
        "LABEL": "位址",
        "PLACE_HOLDER": "位址（例：smtp.gmail.com）"
      },
      "PORT": {
        "LABEL": "連接埠",
        "PLACE_HOLDER": "連接埠"
      },
      "LOGIN": {
        "LABEL": "登入帳號",
        "PLACE_HOLDER": "登入帳號"
      },
      "PASSWORD": {
        "LABEL": "密碼",
        "PLACE_HOLDER": "密碼"
      },
      "DOMAIN": {
        "LABEL": "網域",
        "PLACE_HOLDER": "網域"
      },
      "ENCRYPTION": "加密方式",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL 驗證模式",
      "AUTH_MECHANISM": "驗證機制"
    },
    "NOTE": "注意：",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "網站頭像",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "頭像已成功刪除",
              "ERROR_MESSAGE": "發生錯誤，請重試"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "網站名稱",
          "PLACE_HOLDER": "輸入您的網站名稱（例：Acme Inc）",
          "ERROR": "請輸入有效的網站名稱"
        },
        "WELCOME_HEADING": {
          "LABEL": "歡迎標題",
          "PLACE_HOLDER": "您好！"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "歡迎副標題",
          "PLACE_HOLDER": "我們讓溝通變得簡單。歡迎提出任何問題，或分享您的意見。"
        },
        "REPLY_TIME": {
          "LABEL": "回覆時間",
          "IN_A_FEW_MINUTES": "幾分鐘內",
          "IN_A_FEW_HOURS": "幾小時內",
          "IN_A_DAY": "一天內"
        },
        "WIDGET_COLOR_LABEL": "小工具顏色",
        "WIDGET_BUBBLE": "氣泡",
        "WIDGET_BUBBLE_POSITION_LABEL": "位置：",
        "WIDGET_BUBBLE_TYPE_LABEL": "類型：",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "與我們對話",
          "LABEL": "啟動器標題",
          "PLACE_HOLDER": "與我們對話"
        },
        "UPDATE": {
          "BUTTON_TEXT": "更新小工具設定",
          "API": {
            "SUCCESS_MESSAGE": "小工具設定已成功更新",
            "ERROR_MESSAGE": "無法更新小工具設定"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "預覽",
          "SCRIPT": "程式碼"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "左側",
          "RIGHT": "右側"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "標準",
          "EXPANDED_BUBBLE": "展開氣泡"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "預設",
        "CHAT": "聊天模式"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "通常在幾分鐘內回覆",
        "IN_A_FEW_HOURS": "通常在幾小時內回覆",
        "IN_A_DAY": "通常在一天內回覆"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "開始對話",
        "CHAT_INPUT_PLACEHOLDER": "輸入您的訊息"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "我們在線上",
          "OFFLINE": "我們目前不在線上"
        },
        "USER_MESSAGE": "您好",
        "AGENT_MESSAGE": "哈囉"
      },
      "BRANDING_TEXT": "Powered by Chatwoot",
      "SCRIPT_SETTINGS": "\n      window.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "連結 Microsoft"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "連結 Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "其他供應商",
        "DESCRIPTION": "連結其他供應商"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "網站",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "Email",
      "TELEGRAM": "Telegram",
      "LINE": "LINE",
      "API": "API 頻道",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "語音"
    }
  }
}
